import React from 'react';
import './loader.css';

const Loader = () => {
  return <div className="app-loader cPos"></div>;
};

export default Loader;
